import { render } from "./ColorNoteItem.vue?vue&type=template&id=d28023f8&scoped=true"
import script from "./ColorNoteItem.vue?vue&type=script&lang=ts"
export * from "./ColorNoteItem.vue?vue&type=script&lang=ts"

import "./ColorNoteItem.vue?vue&type=style&index=0&id=d28023f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d28023f8"

export default script